import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import snakecaseKeys from 'snakecase-keys';
import { Icon, LinkBtn } from '../../components';
import BookkeeperNewForm from './BookkeeperNewForm';
import { createBookkeeperRequest } from '../../requests/bookkeepers';
import { sendAlert } from '../../actions/utils';

const BookkeeperNew = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [totalBalances, setTotalBalances] = useState(1);

  const handleSuccess = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    history.push(`/remunerations_settings?tab=bookkeepers`);
  };

  const handleCreateBookkeeper = (bookkeeperValue, setSubmitting) => {
    createBookkeeperRequest({
      dispatch,
      params: snakecaseKeys(bookkeeperValue),
      formData: true,
      successCallback: () => handleSuccess('Cuenta contable creada con éxito'),
      callback: () => setSubmitting(false)
    });
  };

  return (
    <>
      <Row className="mt-4 mb-4 align-items-center">
        <Col xs={1}>
          <LinkBtn variant="circle-dark" className="btn-circle mt-3" block to="/remunerations_settings?tab=bookkeepers">
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>
        <Col>
          <h2 className="text-uppercase mb-0 mt-3">Nueva Cuenta Contable</h2>
        </Col>
      </Row>
      <BookkeeperNewForm
        formRequest={handleCreateBookkeeper}
        setTotalBalances={setTotalBalances}
        totalBalances={totalBalances}
      />
    </>
  );
};
export default BookkeeperNew;
